export default __webpack_public_path__ + "static/media/icon.logo.3ba183b8.svg";